import axios from 'axios';
// 创建axios实例
const request = axios.create({
  baseURL: 'https://mspace-server-subo.51meet.com',
  // baseURL: 'http://10.66.8.83:3000',// 所有的请求地址前缀部分(没有后端请求不用写)
  timeout: 80000,
  withCredentials: true // 异步请求携带cookie
  // headers: {
  // 设置后端需要的传参类型
  // 'Content-Type': 'application/json',
  // 'token': x-auth-token',//一开始就要token
  // 'X-Requested-With': 'XMLHttpRequest',
  // },
});
// request拦截器
request.interceptors.request.use(config => {
  // 如果你要去localStor获取token,(如果你有)
  let token = localStorage.getItem("token");
  if (token) {
    // 添加请求头
    config.headers["Authorization"] = "Bearer " + token;
  }
  return config;
}, error => {
  // 对请求错误做些什么
  Promise.reject(error);
});
// response 拦截器
request.interceptors.response.use(response => {
  // 对响应数据做点什么
  return response.data;
}, error => {
  // 对响应错误做点什么
  if (error.response.status == 401) {
    ElMessageBox.alert('您的登录信息已失效，请重新登录', '提示', {
      // if you want to disable its autofocus
      // autofocus: false,
      confirmButtonText: '确认',
      callback: () => {
        localStorage.removeItem("token");
        window.location.href = "/";
      }
    });
  } else if (error.response.status == 403) {
    // 用于处理详情页重定向
    const redirectPath = error?.response?.headers?.location || '';
    if (redirectPath) {
      // 如果检测到响应头中有location信息，则重定向到location地址
      window.location.href = redirectPath;
    }
  } else {
    return Promise.resolve({
      success: false,
      errCode: error?.response?.data?.errCode ?? 11000,
      status: error?.response?.status ?? 500,
      result: error?.response?.data ?? null
    });
  }
});
export default request;